export const sortArrayOfArraysByIndex = (arr, index: number, order: 'asc' | 'desc') => {
  return arr.sort((a, b) => (order === 'asc' ? a[index] - b[index] : b[index] - a[index]))
}
